import DetailsPage from "../DetailsPage";
import {ObjectTypeId, SyncstepId} from "../../constants";
import {IButton, ICompany, IExportFlow, IExportTemplate, IRouteDefinitionParams} from "../../index";
import {_d, createErrorMessage} from "../../util/misc";
import {global} from "../../appContext";
import {nsExportTemplate} from "./fn";
import {
    getHash,
    getTopParent,
    isRoutePermissionOkay,
    setRouteHash
} from "../../constants/RouteDefinitions";
import pubsub from "../../pubsub";
import {nsSync} from "../../util/nsSync";
import * as ko from "knockout";
import Section = nsExportTemplate.Section;
import VISMA_TYPE = nsExportTemplate.VISMA_TYPE;
import PARENT_PATH_TYPE = nsExportTemplate.PARENT_PATH_TYPE;
import showDBPD = nsExportTemplate.showDBPD;
import detailsHtml from './details.html?raw';

export let template: string = detailsHtml;

const Heading = "Synkroniseringsmal";

export class viewModel extends DetailsPage<IExportTemplate> {
    Section = Section;

    headingLabel: KnockoutObservable<string> = ko.observable(Heading);
    protected ordinaryExportFlows!: IExportFlow[];
    protected ordinaryImportFlows!: IExportFlow[];
    company!: ICompany;
    private isSyncstepOnPremAD!: boolean;

    constructor(params: IRouteDefinitionParams) {
        super(params);
        pubsub.on(this, 'delete.synctemplate.complete', () => {
            const parent = getTopParent(this.__routeId);
            if (parent) {
                setRouteHash(parent);
            }
        });
        this.updateTabs();
    }

    /** Loaded template; only call after `onSuccess` has assigned `data`. */
    private templateData(): IExportTemplate {
        return this.data()!;
    }

    protected override onSuccess(data: [IExportTemplate]) {
        const d = data[0];
        this.data(d);

        this.isSyncstepOnPremAD = nsSync.isSyncstepOnPremAD(d.syncstep?.syncstep?.id);
        this.ordinaryExportFlows = d.exportflow.filter((item: IExportFlow) => nsExportTemplate.isExportFlowOrdinaryExport(item));
        this.ordinaryImportFlows = d.exportflow.filter((item: IExportFlow) => nsExportTemplate.isExportFlowOrdinaryImport(item));
        this.headingLabel(`${Heading} [${d.name}]`);
        global.getPromiseRequest("getcompany")
            .request()
            .then((data: ICompany[]) => {
                const company = data[0];
                if (!company) {
                    throw new Error('Missing company');
                }
                this.company = company;
                this.updateTabs();
                this.updateButtons();
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => this.messageData(createErrorMessage(String(reason))));
    }

    private updateTabs() {
        this.__tabManager?.getTab('synctemplateparentpath')?.isVisible(this.showSection(Section.ParentPath));
        this.__tabManager?.getTab('synctemplatevisma')?.isVisible(this.showSection(Section.Visma));
        this.__tabManager?.getTab('synctemplateexportmappings')?.isVisible(this.showSection(Section.MappingsExport));
        this.__tabManager?.getTab('synctemplateimportmappings')?.isVisible(this.showSection(Section.MappingsImport));
    }

    private updateButtons() {
        // EXPORT PARENT PATH & VISMA
        if (isRoutePermissionOkay('exportflow') && this.templateData()?.active) {
            if (this.showSection(Section.ParentPath)) {
                this.__tabManager?.getTab('synctemplateparentpath')?.addButton(this.getPartialExportButton(PARENT_PATH_TYPE));
            }
            if (this.showSection(Section.Visma)) {
                this.__tabManager?.getTab('synctemplatevisma')?.addButton(this.getPartialExportButton(VISMA_TYPE));
            }
        }
    }

    private showSection(section: Section): boolean {
        switch (section) {
            case Section.ParentPath:
                return this.hasObjectType() && this.isSyncstepOnPremAD;
            case Section.Visma: {
                const a = this.company?.importformathr.name == 'Visma';
                const b = this.isObjectType(ObjectTypeId.User);
                const c = this.isSyncstepOnPremAD;
                return a && b && c;
            }
            case Section.MappingsExport: {
                return this.templateData()?.syncstep?.syncstep.id != SyncstepId.Synchronization
            }
            case Section.MappingsImport:
            case Section.ObjectType:
            case Section.Ruleset:
            case Section.Syncstep: {
                return true;
            }
            default:
                _d.warn("No such section:", section);
                return false;
        }
    }

    private isObjectType(objectTypeId: ObjectTypeId): boolean {
        const objecttype = this.templateData()?.objecttype;
        return !!objecttype && objecttype.id == objectTypeId;
    }

    private hasObjectType(): boolean {
        return !!this.templateData()?.objecttype;
    }

    private getPartialExportButton(type: string): IButton {
        let ret: IButton = {
            icon: "fa-play",
            label: '',
        };
        switch (type) {
            case VISMA_TYPE:
                ret.href = this.getPartialExportUrl("targetattributetype", type);
                ret.description = "Export to|to:Visma";
                ret.label = ret.description as string;
                break;
            case PARENT_PATH_TYPE:
                ret.href = this.getPartialExportUrl("targetattribute", type);
                ret.description = "((Export)) ((parent path|ac))";
                ret.label = ret.description as string;
                break;
        }
        return ret;
    }

    private getPartialExportUrl(key: string, type: string): string {
        const template = this.templateData();
        const ids = template?.exportflow
            .filter((o: IExportFlow) => (<any>o)[key] == type)
            .map((o: IExportFlow) => o.id);
        return getHash('exportflow', {id: template.id, mappingid: ids.join(',')}) ?? '';
    }

    showDBPD(): boolean {
        const template = this.templateData();
        return showDBPD(template.objecttype, template.syncstep);
    }

}
